export default (theme) => ({
  // Clears the absolutely-positioned "Started on ..." caption, which sits in
  // the page's top-right corner and would otherwise land on the card once the
  // window is narrow enough for the two to meet.
  root: {
    paddingTop: 20,
  },
  // puma_ui's Glass: a translucent wash with a 1px stroke, rounded at 8.
  //
  // The stroke is a single alpha rather than Glass's corner-to-corner ramp.
  // CSS can only draw a gradient as a background, and a background fills the
  // whole box — behind a wash this translucent it would tint the entire card
  // instead of just its edge, which reads as a panel darker than the page.
  card: {
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    width: "100%",
    maxWidth: 600,
    margin: "0 auto",
    borderRadius: 8,
    borderStyle: "solid",
    borderWidth: 1,
    padding: 8.5,
  },
  players: {
    flex: 1,
    // Without this the names push the board off the card instead of
    // ellipsizing — flex items refuse to shrink past their content.
    minWidth: 0,
    padding: "6px 0 6px 8px",
  },
  playerRow: {
    display: "flex",
    alignItems: "center",
    minWidth: 0,
    // The flag badge overhangs the avatar circle; nothing may clip it.
    overflow: "visible",
  },
  name: {
    fontFamily: "Futura-Bold",
    fontWeight: 700,
    paddingLeft: 10,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  separator: {
    fontFamily: "Futura-Bold",
    flex: "0 0 auto",
    padding: "0 8px",
  },
  board: {
    display: "flex",
    flex: "0 0 auto",
  },
  column: {
    display: "flex",
    flexDirection: "column",
  },
  // Serving ball / "Winner", in a column of its own to the left of the tiles.
  markerColumn: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    flex: "0 0 auto",
    paddingRight: 4,
  },
  markerCell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  winnerLabel: {
    fontFamily: "Futura-Bold",
    fontSize: 12,
    fontWeight: 700,
    whiteSpace: "nowrap",
  },
  // 2px on every side, so a tile's row is size + 4 tall — the same height as a
  // player row, which is what keeps the two halves of the card aligned.
  tilePad: {
    padding: 2,
  },
  tile: {
    boxSizing: "border-box",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 4,
    borderStyle: "solid",
    borderWidth: 0.8,
    fontFamily: "Futura-Bold",
    fontWeight: 700,
    lineHeight: 1,
  },
  // Tiebreak points, as a superscript in the tile's corner.
  exponent: {
    position: "absolute",
    top: 1,
    right: 2,
    lineHeight: 1,
    fontWeight: 700,
  },
  // Height is reserved whether or not there is a status, so the card doesn't
  // shift every time a game reaches (or leaves) game point.
  status: {
    fontFamily: "Futura-Bold",
    textAlign: "center",
    height: 24,
    lineHeight: "24px",
    marginTop: 6,
  },
});
